// import api from './api';
import {
  ADULT_SETTINGS_KEY,
  ALREADY_ADULT_VERIFIED,
  COOKIE_KEY_VERIFIED_ADULT,
  MOBILE_WEB_HOSTNAME,
  MSG_NEED_FOR_MOVING_LOGIN,
  MSG_VOUCHER_SNS_ALERT,
  NEED_LOGIN,
  NEED_PIN_CODE,
  NEED_VERIFIED,
  NOT_A_ADULT_CONTENT,
  PC_WEB_HOSTNAME,
  SESSION_STORAGE_NOTICE_POPUP_VIEW_KEY,
  SNS_TYPE_LIST,
  URL_COOKIE_DOMAIN,
} from '@/common/constant'
import {
  CommonService,
  getAdultVerificationStatus,
  UserService,
} from '@/common/api/api.service'
import { get, isString, set } from 'lodash'
import { getSessionStorage, getStorage } from '@/common/util/storage.util'
import { EventBus } from '@/components/eventbus/EventBus'
import {
  getType,
  isIos13IPad,
  isMobileDevice,
  isMobileSafari,
} from '@/common/util/ua'
import {
  isPreRenderer,
  removeEmptyProperties,
  findQueryParam,
  isApp,
} from '@/common/util/common'
import { parse, parseUrl, stringify } from 'query-string'
import { DEVICE_TYPE_ANDROID, DEVICE_TYPE_IOS } from '@/common/devicetype.const'
import store from '@/store'
import braze from '@/common/util/braze'
import { getUserExternalId } from '@/common/util/braze.util'
import {
  clearStorageForLogout,
  updateCredentialInCookie,
} from '@/common/util/auth.utils'
import { useConsentRenew } from '@/common/use/useConsentRenew'

const { storage } = useConsentRenew()

// eslint-disable-next-line no-unused-vars
const MOBILE_WEB_LEGACY_HOSTNAME = 'm.pooq.co.kr'
export async function removeVerifiedAdult() {
  utils.cookies.removeItem(COOKIE_KEY_VERIFIED_ADULT, URL_COOKIE_DOMAIN, '/')
}

export async function setAdultContentsSettingsValue() {
  const response = await getAdultVerificationStatus()
  const { settings } = response.data
  console.log('set Adult Content Settings Value : >>', settings)
  utils.cookies.setAdultContentSettingsValue(settings)
  utils.cookies.removeItem(COOKIE_KEY_VERIFIED_ADULT, URL_COOKIE_DOMAIN, '/')
  console.log('remove verifiedAdult value')
}

export async function profileDetailInfo(response) {
  const profileId = get(response, 'data.profile', '0')
  const credential = get(response, 'data.credential', '')
  const { data } = await UserService.getProfileDetailInfo(profileId, credential)
  const { alt, idx, image, profilename } = data
  const addProfileToResponse = Object.assign({}, response.data, {
    profileimage: image,
    alt,
    idx,
    profilename,
  })
  return addProfileToResponse
}

const utils = {
  ip: '',
  guid: '',
  checkAdult: undefined,
  getDeviceId() {
    return isApp()
      ? utils.queryString.getQueryParamValue('device_id')
      : getStorage().get('wavve-device-id')
  },
  isProductMode() {
    return process.env.NODE_ENV === 'production'
  },
  isPreRenderer() {
    return get(window, ['__PRERENDER_INJECTED', 'isPreRender'], '') === 'y'
  },
  redirectHttpToHttps() {
    if (
      !this.isPreRenderer() &&
      this.isProductMode() &&
      window.location.protocol === 'http:'
    ) {
      let url =
        'https:' +
        window.location.href.substring(window.location.protocol.length)
      window.location.replace(url)
    }
  },
  allowDeviceCheck(toUrl = null) {
    if (isPreRenderer()) return
    const deviceType = getType()
    const queryDevice = findQueryParam('device')?.toLowerCase()
    const isQueryDeviceTypeIsMobile =
      queryDevice === DEVICE_TYPE_ANDROID || queryDevice === DEVICE_TYPE_IOS
    const isPooqzonePage =
      location.pathname === '/pooqzone.html' ||
      location.pathname === '/wavveon.html'
    if (this.isProductMode() && !this.isPreRenderer() && !isPooqzonePage) {
      if (
        deviceType !== 'mobile' &&
        !isIos13IPad() &&
        deviceType !== 'tablet' &&
        !isQueryDeviceTypeIsMobile
      ) {
        if (toUrl === null) {
          location.replace(
            location.href.replace(location.hostname, 'www.wavve.com'),
          )
        } else {
          location.replace(toUrl)
        }
      }
    }
  },
  redirectWithParams() {
    if (isPreRenderer()) return
    const isProduction = process.env.NODE_ENV === 'production'
    const isPooqDomain = location.hostname === MOBILE_WEB_LEGACY_HOSTNAME
    // const isMyPooqPath = location.pathname.indexOf('/mypooq/') > -1
    // const isVoucherPath = location.pathname.indexOf('/voucher/') > -1
    // const isMemberPath = location.pathname.indexOf('/member/') > -1
    // const { query } = parseUrl(location.href)
    // const device = get(query, 'device', 'mobile')
    // const isMobileWeb = device === 'mobile'
    // const isRootPath = location.pathname === '/' || location.pathname === '/index' || location.pathname === '/index.html'
    if (isProduction && isPooqDomain) {
      // if (isMobileWeb) {
      location.replace(location.href.replace(location.hostname, 'm.wavve.com'))
      // } else {
      //   if (!isMyPooqPath && !isVoucherPath && !isMemberPath) {
      //     location.replace(location.href.replace(location.hostname, 'm.wavve.com'))
      //   }
      // }
    }
  },
  getCheckAdult() {
    if (typeof utils.checkAdult === 'undefined') {
      utils.checkAdult = utils.cookies.getItem(COOKIE_KEY_VERIFIED_ADULT)
    }
    return utils.checkAdult === '1'
  },
  hasAdultContent(cellList = []) {
    const filterd = cellList.filter((cell) => {
      const age = get(cell, 'age', '')
      return age === '19' || age === '19+'
    })
    return filterd.length
  },
  // 전달받은 리소스에 지정된 postfix 를 붙여서 리턴
  // addPostfix (source, postfix) {
  //   if (source === undefined || source === '') {
  //     return ''
  //   }
  //   let ext = '.' + source.split('.').pop()
  //   let pattern = new RegExp('\\' + ext + '$', 'g')
  //   return source.replace(pattern, '_' + postfix + ext)
  // },
  // // 전달받은 리소스에 지정된 postfix 를 붙인 뒤 현재 프로토콜을 추가해서 리턴
  // addPostfixAndUrl (source, postfix) {
  //   return window.location.protocol + '//' + this.addPostfix(source, postfix)
  // },
  url(url) {
    if (url.indexOf(PC_WEB_HOSTNAME) > -1) {
      return url.replace(PC_WEB_HOSTNAME, '')
    } else if (url.startsWith('http')) {
      return url
    } else if (url) {
      return location.protocol + '//' + url
    }
    return ''
  },
  getPgName() {
    return utils.queryString.getQueryParamValue('pgname', '')
  },
  asyncConfirm(text) {
    if (isMobileSafari() || isIos13IPad()) {
      return new Promise((resolve, reject) => {
        EventBus.$emit('open-confirm', {
          text: text.replace(/\n/gi, '<br/>'),
          resolveFn: resolve,
        })
      })
    } else {
      return new Promise((resolve, reject) => {
        resolve(confirm(text.replace(/<br\/>/gi, '\n')))
      })
    }
  },
  alert(text, callbackFn) {
    if (isMobileSafari() || isIos13IPad()) {
      EventBus.$emit('open-alert', { text, callbackFn })
    } else {
      alert(text)
      if (callbackFn) {
        callbackFn()
      }
    }
  },
  toast(message, vue) {
    let device = utils.cookies.getDevice()
    if (device === 'mobile') {
      vue.$toast({ message })
      return
    }
    try {
      if (device === DEVICE_TYPE_IOS) {
        window.webkit.messageHandlers.showToast.postMessage(message)
      } else if (device === DEVICE_TYPE_ANDROID) {
        window.Android.showToast(message)
      }
    } catch (err) {
      console.log(err)
    }
  },
  getTimeStamp() {
    let date = new Date()
    let requestTime = ''
    requestTime += date.getFullYear() + '-'
    requestTime += ('00' + (date.getMonth() + 1)).slice(-2) + '-'
    requestTime += ('00' + date.getDate()).slice(-2) + ' '
    requestTime += ('00' + date.getHours()).slice(-2) + ':'
    requestTime += ('00' + date.getMinutes()).slice(-2) + ':'
    requestTime += ('00' + date.getSeconds()).slice(-2)
    return requestTime + '+900'
  },
  cookies: {
    getItem(key) {
      if (!key) {
        return null
      }
      return (
        decodeURIComponent(
          document.cookie.replace(
            new RegExp(
              '(?:(?:^|.*;)\\s*' +
                encodeURIComponent(key).replace(/[-.+*]/g, '\\$&') +
                '\\s*\\=\\s*([^;]*).*$)|^.*$',
            ),
            '$1',
          ),
        ) || null
      )
    },
    setItem(key, value, expire, domain, path, secure) {
      if (!key || /^(?:expires|max-age|path|domain|secure)$/i.test(key)) {
        return false
      }
      let datas = ''
      datas += encodeURIComponent(key)
      datas += '='
      datas += encodeURIComponent(value)
      if (expire) {
        switch (expire.constructor) {
          case String:
            datas += '; expires='
            datas += expire
            break
          case Date:
            datas += '; expires='
            datas += expire.toUTCString()
            break
          default:
            break
        }
      }
      datas += domain ? '; domain=' + domain : ''
      datas += path ? '; path=' + path : ''
      datas += secure ? '; secure=' + secure : ''
      document.cookie = datas
      return true
    },
    setAdultContentSettingsValue(value) {
      const settingsValue = value === 'H' ? 'N' : value
      this.setItem(
        ADULT_SETTINGS_KEY,
        settingsValue,
        null,
        URL_COOKIE_DOMAIN,
        '/',
      )
    },
    removeAdultContentSettingsValue() {
      this.removeItem(ADULT_SETTINGS_KEY, URL_COOKIE_DOMAIN, '/')
    },
    setAutoLoginCredential(credential) {
      let expires = new Date()
      expires.setHours(0, 0, 0, 0)
      expires.setDate(expires.getDate() + 365)
      this.setItem(
        'credential',
        JSON.stringify(credential),
        expires.toUTCString(),
        URL_COOKIE_DOMAIN,
        '/',
      )
    },
    removeAutoLoginCredential() {
      this.removeItem('credential', URL_COOKIE_DOMAIN, '/')
    },
    removeItem(key, domain, path) {
      if (!key) {
        return false
      }
      document.cookie =
        encodeURIComponent(key) +
        '=; expires=Thu, 01 Jan 1970 00:00:00 GMT' +
        (domain ? '; domain=' + domain : '') +
        (path ? '; path=' + path : '')
      return true
    },
    hasItem(key) {
      if (!key) {
        return false
      }
      return new RegExp(
        '(?:^|;\\s*)' +
          encodeURIComponent(key).replace(/[-.+*]/g, '\\$&') +
          '\\s*\\=',
      ).test(document.cookie)
    },
    clear() {
      let nameList = document.cookie
        .replace(/((?:^|\s*;)[^=]+)(?=;|$)|^\s*|\s*(?:=[^;]*)?(?:\1|$)/g, '')
        .split(/\s*(?:=[^;]*)?;\s*/)
      let name = null
      for (let i = 0, len = nameList.length; i < len; i++) {
        name = nameList[i]
        if (/^_ga.*|^wcs.*|^usrID/gi.test(name) === true) {
          continue
        }
        this.removeItem(decodeURIComponent(name), URL_COOKIE_DOMAIN)
        this.removeItem(decodeURIComponent(name), URL_COOKIE_DOMAIN, '/')
      }
    },
    changeUserInfo(name, image) {
      let userInfo = utils.cookies.userInfo()
      userInfo.profilename = name
      userInfo.profileimage = image
      utils.cookies.setItem(
        'cs',
        JSON.stringify(userInfo),
        null,
        URL_COOKIE_DOMAIN,
        '/',
      )
    },
    userInfo(key) {
      let userInfo = JSON.parse(this.getItem('cs'))
      if (key) {
        return userInfo ? userInfo[key] : undefined
      }
      return userInfo
    },
    isSetPooqZone() {
      return this.getItem('pz') !== null
    },
    isPooqZone() {
      let pz = JSON.parse(this.getItem('pz'))
      return pz ? pz['isPooqzone'] : false
    },
    isCsInfo() {
      return this.getItem('cs') !== null
    },
    isPpvConfirmUser() {
      const csInfo = JSON.parse(this.getItem('cs'))
      return get(csInfo, 'movieuicode', '') === 'GN17'
    },
    setMovieUiCodeToGN17() {
      let csInfo = JSON.parse(this.getItem('cs'))
      if (csInfo !== null) {
        csInfo = set(csInfo, 'movieuicode', 'GN17')
        this.setItem('cs', JSON.stringify(csInfo), null, URL_COOKIE_DOMAIN, '/')
      }
    },
    getPooqZoneInfo() {
      return JSON.parse(this.getItem('pzInfo'))
    },
    getPooqZoneId() {
      let pzInfo = JSON.parse(this.getItem('pzInfo'))
      return pzInfo ? pzInfo['pooqzoneid'] : 'none'
    },
    getSaveUserId() {
      let userId = this.getItem('userId')
      return userId || 'none'
    },
    getUno() {
      let csInfo = JSON.parse(this.getItem('cs'))
      return csInfo ? csInfo['uno'] : 'none'
    },
    getDevice() {
      // android, ios 일때만
      // credential 을 app-credentail 에 넣을껀지를 결정한다.
      // getClientInfo 를 브릿지로 호출 해서 있으면 인정, 없으면 인정 안함
      let device = utils.queryString.getQueryParamValue('device')
      if (device === DEVICE_TYPE_IOS || device === DEVICE_TYPE_ANDROID) {
        if (window.Android !== undefined || window.webkit !== undefined) {
          this.setItem('app-device', device, null, URL_COOKIE_DOMAIN, '/')
          const credential =
            utils.queryString.getQueryParamValue('credential') ||
            utils.queryString.getQueryParamValue('cpToken')
          const pooqzone = utils.queryString.getQueryParamValue('pooqzone')
          const drm = utils.queryString.getQueryParamValue('drm')

          if (credential) {
            this.setItem(
              'app-credential',
              encodeURIComponent(credential),
              null,
              URL_COOKIE_DOMAIN,
              '/',
            )
          }
          if (pooqzone) {
            this.setItem('app-pooqzone', pooqzone, null, URL_COOKIE_DOMAIN, '/')
          }
          if (drm) {
            this.setItem('app-drm', drm, null, URL_COOKIE_DOMAIN, '/')
          }
          return device
        }
      }
      device = this.getItem('app-device')
      return device || 'mobile'
    },
    getTargetAge() {
      const device = utils.queryString.getQueryParamValue('device')
      if (device === DEVICE_TYPE_IOS || device === DEVICE_TYPE_ANDROID) {
        let targetage = utils.queryString.getQueryParamValue('targetage')
        return targetage === '' ? 'all' : targetage
      } else {
        return 'all'
      }
    },
    getPooqZone() {
      let appPooqzone = this.getItem('app-pooqzone')
      return appPooqzone || utils.cookies.getPooqZoneType()
    },
    getPooqZoneType() {
      let pzInfo = JSON.parse(this.getItem('pzInfo'))
      return pzInfo ? pzInfo['pooqzonetype'] : 'none'
    },
    getPooqZoneTempInfo() {
      return JSON.parse(this.getItem('pzInfo'))
    },
    getDrm() {
      let appDrm = this.getItem('app-drm')
      return appDrm || 'wm'
    },
    getProfileId() {
      const csInfo = JSON.parse(this.getItem('cs'))
      return csInfo ? csInfo['profile'] : 'none'
    },
    getCredential() {
      let appCredential = this.getItem('app-credential')
      if (appCredential) {
        return decodeURIComponent(appCredential)
      }

      let csInfo = JSON.parse(this.getItem('cs'))
      return csInfo ? decodeURIComponent(csInfo['credential']) : 'none'
    },
    getAutoLoginCredential() {
      return JSON.parse(this.getItem('credential'))
    },
  },
  queryString: {
    origin:
      location.search.indexOf('?') === 0
        ? location.search.substring(1).toString()
        : location.search.toString(),
    query:
      location.search.indexOf('?') === 0
        ? location.search.substring(1).toString()
        : location.search.toString(),
    parseQuery(isChaining = false) {
      if (this.origin === '') {
        return null
      }
      let pair = []
      let parseArr
      parseArr = isChaining
        ? this.query.split(/[&;]/)
        : this.origin.split(/[&;]/)
      let item = null
      let idx = null
      for (let i = 0, len = parseArr.length; i < len; i++) {
        item = parseArr[i]
        idx = item.indexOf('=')
        if (idx !== 0) {
          pair.push(
            idx < 0
              ? [item, null]
              : [
                  decodeURIComponent(item.split('=')[0]),
                  decodeURIComponent(item.split('=')[1]),
                ],
          )
        }
      }
      return pair
    },
    trimming() {
      let queryPairs = this.parseQuery()
      let newQueryPairs = []
      if (queryPairs) {
        let item = null
        for (let i = 0, len = queryPairs.length; i < len; i++) {
          item = queryPairs[i]
          if (item[1] !== '') {
            newQueryPairs.push(item.join('='))
          }
        }
        this.query = newQueryPairs.join('&')
      }
      return this
    },
    getQueryParamValue(key, defaultValue) {
      return findQueryParam(key) || defaultValue
    },
    deleteQueryParam(key, isChaining = false) {
      let queryPairs = this.parseQuery()
      let newQueryPairs = []
      if (queryPairs) {
        let item = null
        for (let i = 0, len = queryPairs.length; i < len; i++) {
          item = queryPairs[i]
          if (key !== item[0]) {
            newQueryPairs.push(item.join('='))
          }
        }
        this.query = newQueryPairs.join('&')
      }

      if (isChaining) {
        this.origin = this.query
      }

      return this
    },
    addQueryParam(key, val, isChaining) {
      this.query = [
        this.origin,
        this.origin === '' ? '' : '&',
        encodeURIComponent(key),
        '=',
        encodeURIComponent(val),
      ].join('')

      if (isChaining) {
        this.origin = this.query
      }

      return this
    },
    replaceQueryParam(key, val, isChaining = false) {
      let queryPairs = this.parseQuery()
      let newQueryPairs = []
      let isReplace = false

      if (queryPairs) {
        let item = null
        for (let i = 0, len = queryPairs.length; i < len; i++) {
          item = queryPairs[i]
          if (key === item[0]) {
            item[1] = encodeURIComponent(val)
            newQueryPairs.push(item.join('='))
            isReplace = true
          } else {
            newQueryPairs.push(item.join('='))
          }
        }
        this.query = newQueryPairs.join('&')

        if (!isReplace) {
          this.addQueryParam(key, val)
        }
      } else {
        this.addQueryParam(key, val)
      }

      if (isChaining) {
        this.origin = this.query
      }

      return this
    },
    getUrl() {
      let query = this.query
      return query ? location.pathname + '?' + query : location.pathname
    },
    getRefererUrl() {
      return location.pathname
    },
    /**
     * url에 쿼리스트링을 추가하여 반환 (빈스트링, null, undefined인 경우 추가 안함)
     * @param {string} origin
     * @param {object|string} params
     * @returns {string}
     */
    concatParams(origin, params) {
      if (!params) return origin
      const [path, queryString] = origin.split('?')
      const originParams = parse(queryString)
      const newParams = isString(params) ? parse(params) : params
      const mergeParams = removeEmptyProperties({
        ...originParams,
        ...newParams,
      })
      return Object.keys(mergeParams).length !== 0
        ? `${path}?${stringify({ ...mergeParams })}`
        : path
    },
  },
  pz: {
    // 웨이브온
    /************************************************************************
     * 웨이브온 체크
     * 1. 웨이브온 초기설정 체크---------> /index.html 들어올때 마다 매번 체크 or 모든 페이지에서 웨이브온체크
     * 2. 웨이브온 자동 로그인 체크 -----> 필요함?
     * 3. 웨이브온IP 여부 체크
     * 4. 상품(방송이용권(방송), 슈퍼팩 이용권(방송+영화)) 보유여부 체크
     * 5. 웨이브온 페이지 이동 or index 페이지 이동
     */
    pooqZoneCheck() {
      // 웨이브온 초기설정 체크 (pz 쿠키값 여부 체크)
      if (utils.cookies.isSetPooqZone() === false) {
        // 웨이브온 자동 로그인 체크
        if (utils.cookies.isPooqZone() === true) {
          // 웨이브온 정보 조회?
        } else {
          /***********************************
           * 웨이브온 URL 체크
           * status값이 200이면 무조건 웨이브온인지 확인
           */
          CommonService.pooqzoneCheck()
            .then((response) => {
              if (response.status === 200) {
                // 쿠키값 삭제 or 저장
                utils.cookies.removeItem('pzInfo', URL_COOKIE_DOMAIN, '/')
                utils.cookies.setItem(
                  'pzInfo',
                  JSON.stringify(response.data),
                  null,
                  URL_COOKIE_DOMAIN,
                  '/',
                )

                // 웨이브온 이동
                if (response.data) {
                  window.location.href = '/pooqzone.html'
                } else {
                  window.location.href = '/index.html'
                }
              } else {
                utils.cookies.removeItem('pzInfo', URL_COOKIE_DOMAIN, '/')
                utils.cookies.setItem(
                  'pz',
                  JSON.stringify({ isPooqZone: false }),
                  null,
                  URL_COOKIE_DOMAIN,
                  '/',
                )
              }
            })
            .catch((error) => {
              if (error.response.data.resultcode === '100') {
                // 웨이브온이 아닙니다.
                utils.cookies.setItem(
                  'pz',
                  JSON.stringify({ isPooqZone: false }),
                  null,
                  URL_COOKIE_DOMAIN,
                  '/',
                )

                // 다시한번 로드
                window.location.href = '/index.html'
              }
            })
        }
      }
    },
  },
  login: {
    // 쿠키 내 크리덴셜 유무로 로그인 여부 판별
    isLogin() {
      return utils.cookies.getCredential() !== 'none'
    },
    // 로그인
    loginProc(
      { userType, userId, userPassword, saveId, autoLogin, profile = '0' },
      catchFn,
    ) {
      // TODO: 로그인 만료 기간 확인
      // 만료일 설정
      let expires = new Date()
      expires.setHours(0, 0, 0, 0)
      expires.setDate(expires.getDate() + 365)

      return UserService.login(
        {
          type: userType,
          id: userId,
          pushid: 'none',
          password: userPassword,
          profile: String(profile),
          credential: '',
        },
        catchFn,
      ).then(async (response) => {
        if (get(response, 'status', 500) !== 200) return
        const addProfileToResponse = await profileDetailInfo(response)
        let dataJson = Object.assign(
          { isPooqZone: false },
          addProfileToResponse,
        )
        getSessionStorage().remove(SESSION_STORAGE_NOTICE_POPUP_VIEW_KEY)
        utils.cookies.setItem(
          'cs',
          JSON.stringify(dataJson),
          null,
          URL_COOKIE_DOMAIN,
          '/',
        )
        // 아이디 저장
        if (saveId) {
          utils.cookies.setItem(
            'userId',
            userId,
            expires.toUTCString(),
            URL_COOKIE_DOMAIN,
            '/',
          )
        } else {
          utils.cookies.removeItem('userId', URL_COOKIE_DOMAIN, '/')
        }
        // 자동 로그인
        if (autoLogin) {
          utils.cookies.setAutoLoginCredential(addProfileToResponse.credential)
        }
        localStorage.setItem('user-id', userId)
        braze.connectUser(getUserExternalId())
        storage.setSessionConsentCheck('true')
        await setAdultContentsSettingsValue()
        return response
      })
    },
    /**
     * credentialAutoLogin과 마찬가지로 credential 로그인을 수행하지만
     * credential로그인 api 호출 성공/실패 결과만을 리턴한다.
     */
    async credentialLogin(credential) {
      if (!credential || credential === 'none') {
        return
      }
      const response = await UserService.login(
        {
          type: 'credential',
          id: credential,
          pushid: '',
          password: '',
          profile: '',
        },
        (error) => {
          return error.response
        },
      )

      return response
    },

    async credentialAutoLogin(credential, isMultiLine = false, reload = true) {
      if (credential !== 'none') {
        try {
          const result = await UserService.login(
            {
              type: 'credential',
              id: credential,
              pushid: '',
              password: '',
              profile: isMultiLine ? '0' : '',
            },
            null,
          )
          const loginData = Object.assign({ isPooqZone: false }, result.data)
          utils.cookies.setItem(
            'cs',
            JSON.stringify(loginData),
            null,
            URL_COOKIE_DOMAIN,
            '/',
          )
          store.commit('setCsInfo', JSON.parse(utils.cookies.getItem('cs')))
          getSessionStorage().remove(SESSION_STORAGE_NOTICE_POPUP_VIEW_KEY)
          await setAdultContentsSettingsValue()
          return result
        } catch (e) {
          utils.cookies.removeAutoLoginCredential()
          reload && window.location.reload(true)
        }
      }
    },
    async autoLoginProc() {
      let result

      // 웹뷰에서는 자동 로그인 처리 우회
      if (utils.cookies.getDevice() !== 'mobile') {
        return
      }

      if (!utils.cookies.isCsInfo() && utils.cookies.getAutoLoginCredential()) {
        // 자동 로그인 설정된 회원 로그인
        let credential = utils.cookies.getAutoLoginCredential()
        const response = await utils.login.credentialAutoLogin(credential)
        utils.cookies.setAutoLoginCredential(
          get(response, 'data.credential', ''),
        )
      } else if (utils.cookies.hasItem('signup-credential')) {
        // 회원 가입 후 로그인 처리
        let credential = utils.cookies.getItem('signup-credential')
        result = await UserService.login(
          {
            type: 'credential',
            id: credential,
            pushid: '',
            password: '',
            profile: '',
          },
          null,
        )
        try {
          const loginData = Object.assign({ isPooqZone: false }, result.data)
          utils.cookies.setItem(
            'cs',
            JSON.stringify(loginData),
            null,
            URL_COOKIE_DOMAIN,
            '/',
          )
          utils.cookies.removeItem('signup-credential', URL_COOKIE_DOMAIN, '/')
          await setAdultContentsSettingsValue()
        } catch (error) {
          console.error(error)
        }
      } else if (utils.cookies.hasItem('pwdChanged')) {
        // 비밀번호 변경 후 재 로그인 처리
        try {
          let credential = utils.cookies.getItem('pwdChanged')
          result = await UserService.login(
            {
              type: 'credential',
              id: credential,
              pushid: '',
              password: '',
              profile: '',
            },
            null,
          )
          const loginData = Object.assign({ isPooqZone: false }, result.data)
          utils.cookies.setItem(
            'cs',
            JSON.stringify(loginData),
            null,
            URL_COOKIE_DOMAIN,
            '/',
          )
          utils.cookies.removeItem('pwdChanged', URL_COOKIE_DOMAIN, '/')
          await setAdultContentsSettingsValue()
        } catch (error) {
          console.error(error)
        }
      } else if (utils.cookies.hasItem('member-logout')) {
        this.logoutProc().then(() => {
          utils.cookies.removeItem('member-logout', URL_COOKIE_DOMAIN, '/')
          utils.cookies.removeAdultContentSettingsValue()
          window.location.href = '/index.html'
        })
      } else {
        /**
         * NOTE
         * credential이 유효한지 판별하기 위한 로직
         * 타 디바이스에서 현재 접속한 기기를 로그아웃 시켰다면 (MY > 디바이스 관리 메뉴)
         * 현재 기기에 저장된 credential이 유효하지 않기 때문에 로그아웃 처리가 필요하다.
         */
        if (utils.login.isLogin()) {
          const credential = utils.cookies.getCredential()

          const credentialValidation =
            await utils.login.checkValidCredential(credential)
          const { isValid, response } = credentialValidation
          if (!isValid) {
            clearStorageForLogout()
            location.reload(true)
          } else {
            const { credential } = response?.data
            updateCredentialInCookie(credential)
          }
        }
      }
      braze.connectUser(getUserExternalId())
      return result
    },
    async checkValidCredential(credential) {
      const result = {
        isValid: false,
        result: null,
      }
      const loginResponse = await utils.login.credentialLogin(credential)
      if (loginResponse?.status === 200) {
        result.isValid = true
      }
      result.response = loginResponse
      return result
    },
    changeProfileProc(profileId = '0') {
      let credential = utils.cookies.getCredential()
      let result = null

      if (utils.cookies.isPooqZone() === true) {
        // 웨이브온 자동 로그인
      } else {
        // 유료회원 자동 로그인
        if (credential !== 'none') {
          result = UserService.login(
            {
              type: 'credential',
              id: credential,
              pushid: '',
              password: '',
              profile: String(profileId),
            },
            null,
          )
            .then(async (response) => {
              const addProfileToResponse = await profileDetailInfo(response)
              let responseArray = Object.assign(
                { isPooqZone: false },
                addProfileToResponse,
              )
              utils.cookies.setItem(
                'cs',
                JSON.stringify(responseArray),
                null,
                URL_COOKIE_DOMAIN,
                '/',
              )
              braze.connectUser(getUserExternalId())
              if (utils.cookies.getAutoLoginCredential()) {
                utils.cookies.setAutoLoginCredential(
                  addProfileToResponse.credential,
                )
              }
              await setAdultContentsSettingsValue()
            })
            .catch(() => {})
        }
      }
      // 프로필 변경할때 성인인증 페이지로 이동
      utils.cookies.removeItem(
        COOKIE_KEY_VERIFIED_ADULT,
        URL_COOKIE_DOMAIN,
        '/',
      )
      return result
    },
    pinCodeLoginProc(pinCode) {
      let tmpArr = null
      let pooqzoneid = utils.cookies.getPooqZoneId()
      let result = UserService.pooqzoneLogin({
        pooqzoneid: pooqzoneid,
        pincode: pinCode,
      })
      result
        .then((response) => {
          tmpArr = Object.assign({ isPooqZone: true }, response.data)
          utils.cookies.setItem(
            'pz',
            JSON.stringify({ isPooqZone: true }),
            null,
            URL_COOKIE_DOMAIN,
            '/',
          )
          utils.cookies.setItem(
            'cs',
            JSON.stringify(tmpArr),
            null,
            URL_COOKIE_DOMAIN,
            '/',
          )
          braze.connectUser(getUserExternalId())
        })
        .catch(() => {})
      return result
    },
    logoutProc() {
      return UserService.logout({ pushid: '' })
        .then((response) => {
          clearStorageForLogout()
          return response
        })
        .catch(() => {})
    },
    getMemberSnsLoginUrl({ type, callback }) {
      return `https://member.wavve.com/sns/${type}/signin?callback=${encodeURIComponent(utils.queryString.concatParams(callback, { type }))}&response_type=sns_connection`
    },
  },
  common: {
    /**
     * 비로그인 사용자가 로그인이 필요한 페이지에 접근하는지 체크, 로그인 화면으로 보낸다.
     */
    checkPermission() {
      if (
        utils.cookies.getDevice() === 'mobile' &&
        utils.cookies.getCredential() === 'none'
      ) {
        if (utils.cookies.getAutoLoginCredential()) {
          return true
        }

        let path = window.location.pathname
        if (path.startsWith('/mypooq') || path.startsWith('/member/profile')) {
          window.location.href =
            '/member/login.html?referer=' +
            encodeURIComponent(window.location.href)
          return true
        }
      }
      return false
    },
    /**
     * more_link를 눌렀을 때 처리
     */
    clickLink(linkUrl) {
      if (linkUrl.startsWith(PC_WEB_HOSTNAME)) {
        window.location.href = linkUrl.replace(PC_WEB_HOSTNAME, '')
      } else if (linkUrl.startsWith('member.wavve.com')) {
        const { url, query } = parseUrl(linkUrl)
        query.device = 'mobile'
        window.location.href =
          window.location.protocol + '//' + url + '?' + stringify(query)
      } else if (linkUrl.startsWith(MOBILE_WEB_HOSTNAME)) {
        window.open(window.location.protocol + '//' + linkUrl, '_blank')
      } else {
        window.open(linkUrl, '_blank')
      }
    },
    /**
     * 성인 인증 체크
     * 상태 값
     * ALREADY_ADULT_VERIFIED - 로그인 하고 이미 시청하기 누른상태
     * NEED_LOGIN - 로그인 하지 않은 상태
     * NEED_VERIFIED - 로그인은 했으나 시청하기 버튼을 누르지 않은 상태
     */
    // verifyAdult (targetage) {
    //   let res = ALREADY_ADULT_VERIFIED
    //   if (!(targetage && +targetage >= 18) || (utils.cookies.getCredential() !== 'none' && utils.cookies.getItem(COOKIE_KEY_VERIFIED_ADULT) === '1')) {
    //     res = ALREADY_ADULT_VERIFIED
    //   } else if (utils.cookies.getCredential() === 'none') {
    //     res = NEED_LOGIN
    //   } else {
    //     res = NEED_VERIFIED
    //   }
    //   return res
    // },
    isCheckNextYearDateAndToday(adultVerification) {
      if (utils.cookies.getCredential() === 'none')
        return { isLessThenYear: false }
      const today = new Date()
      const oneYearLater = new Date(
        +adultVerification.substr(0, 4) + 1,
        +adultVerification.substr(5, 2) - 1,
        +adultVerification.substr(8, 2),
      )
      return {
        isLessThenYear: today <= oneYearLater,
        nextYearDate: oneYearLater,
      }
    },
    async userInfoAdultVerifiedDate() {
      const userRes = await UserService.userInfo()
      const userData = get(userRes, 'data', {})
      const adultVerification = get(userData, 'adultverification', '')
      const { isLessThenYear = false, nextYearDate = '' } =
        utils.common.isCheckNextYearDateAndToday(adultVerification)
      if (isLessThenYear && utils.cookies.getItem(ADULT_SETTINGS_KEY) !== 'L')
        utils.cookies.setItem(
          COOKIE_KEY_VERIFIED_ADULT,
          '1',
          nextYearDate.toUTCString(),
          URL_COOKIE_DOMAIN,
          '/',
        )
    },
    async verifyAdult(targetage) {
      const isAdultContent = targetage && +targetage >= 18
      const isLoginUser = utils.cookies.getCredential() !== 'none'
      if (isAdultContent) {
        if (isLoginUser) {
          const result = await getAdultVerificationStatus()
          const data = result.data
          const { settings } = data
          if (settings !== utils.cookies.getItem(ADULT_SETTINGS_KEY)) {
            utils.cookies.removeItem(
              COOKIE_KEY_VERIFIED_ADULT,
              URL_COOKIE_DOMAIN,
              '/',
            )
            utils.cookies.setAdultContentSettingsValue(settings)
          }
        }
        await utils.common.userInfoAdultVerifiedDate()
        const isVerifiedAdult =
          utils.cookies.getItem(COOKIE_KEY_VERIFIED_ADULT) === '1'
        const settings = utils.cookies.getItem(ADULT_SETTINGS_KEY)
        if (isLoginUser) {
          if (isVerifiedAdult) {
            return ALREADY_ADULT_VERIFIED
          } else {
            if (settings === 'L') {
              return NEED_PIN_CODE
            } else {
              return NEED_VERIFIED
            }
          }
        } else {
          return NEED_LOGIN
        }
      } else {
        return NOT_A_ADULT_CONTENT
      }
    },
    setReplaceAll(content, word, changeWord) {
      let re = new RegExp(word, 'g')
      if ((content && content.indexOf(word) >= 0) || typeof word === 'object') {
        content = content.replace(re, changeWord)
      }
      return content
    },
    setEnterChange(content, changeWord) {
      return content
        .replace(/\\r\\n/g, '<br />')
        .replace(/\\\\n/g, '<br />')
        .replace(/\\n/g, '<br />')
    },
    back(loc) {
      if (document.referrer) {
        history.back()
      } else {
        location.href = loc
      }
    },
    imageUrl(url) {
      let img = url
      let dotIndex
      if (img) {
        // 이미지 서버에 있는 파일인 경우 모바일 사이즈에 맞게 리사이징 된 이미지를 가져오기 위해 확장자 앞에 _2를 붙인다.
        if (
          img.startsWith('http://img.pooq.co.kr/') ||
          img.startsWith('img.pooq.co.kr/')
        ) {
          dotIndex = img.lastIndexOf('.')
          if (dotIndex > -1)
            img = img.slice(0, dotIndex) + '' + img.slice(dotIndex)
        }
        return img.startsWith('http') ? img : location.protocol + '//' + img
      }
      return ''
    },
    getSecondToTime(seconds) {
      let playTime = ''
      let hour = Math.floor(seconds / 3600)
      let minute = Math.floor((seconds % 3600) / 60)
      let second = ''

      if (seconds < 60) {
        // 초 데이터
        if (seconds < 10) second = '00:' + '0' + seconds
        if (seconds > 10) second = '00:' + seconds

        playTime = second
      } else if (seconds < 3600) {
        // 분초 데이터
        second = seconds - minute * 60

        if (minute < 10) minute = '0' + minute
        if (second < 10) second = '0' + second

        playTime = minute + ':' + second
      } else {
        // 시분초 데이터
        second = seconds - hour * 3600 - minute * 60

        if (minute < 10) minute = '0' + minute
        if (second < 10) second = '0' + second

        playTime = hour + ':' + minute + ':' + second
      }
      return playTime
    },
    isNumberCheck(text) {
      let regNumber = /^[0-9]*$/
      return regNumber.test(text)
    },
    setSearchWordSave(text) {
      // 검색어 저장 조회
      let str = ''
      let data = localStorage.getItem('search-history')
      let historyList = data ? data.split('&') : []
      let duplCheck = historyList.indexOf(text)
      // 중복체크
      if (duplCheck >= 0) {
        historyList.splice(duplCheck, 1)
      }
      // 최대 20개 체크
      if (historyList.length === 20) {
        historyList.splice(19, 1)
      }
      str = this.setReplaceAll(text, '&', '@-@')
      if (historyList.length > 0) {
        str += '&' + historyList.join('&')
      }
      localStorage.setItem('search-history', str)
      return true
    },
    getDrm() {
      let agent = navigator.userAgent.toLowerCase()

      // IE
      if (agent.indexOf('msie') !== -1 || agent.indexOf('trident') !== -1) {
        return 'wc'
      } else if (
        agent.indexOf('chrome') !== -1 ||
        agent.indexOf('firefox') !== -1
      ) {
        return 'wm'
      }

      return 'none'
    },
    setLibFile(d, s, id, url) {
      let js
      let fjs = d.getElementsByTagName(s)[0]
      if (d.getElementById(id)) {
        return
      }
      js = d.createElement(s)
      js.id = id
      js.src = url
      fjs.parentNode.insertBefore(js, fjs)
    },
    isArrayCompare(standardArr, compareArr) {
      let i = 0
      let tempCnt = 0
      for (i = 0; i <= standardArr.length; i++) {
        if (compareArr.indexOf(standardArr[i]) > -1) {
          tempCnt++
        }
      }
      return tempCnt === compareArr.length
    },
    setNumberCommas(data) {
      return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    setEnableScrolling(isEnable) {
      if (isEnable) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = ''
      }
    },
    /**
     * 저장된 크레덴셜이 없을 때 로그인이 필요하다는 confirm 창을 띄운다.
     */
    // async showRequiredLoginPopup (referer) {
    //   if (utils.cookies.getCredential() === 'none' && utils.cookies.getDevice() === 'mobile') {
    //     let confirmLogin = await utils.asyncConfirm(MSG_NEED_FOR_MOVING_LOGIN)
    //     if (confirmLogin) {
    //       window.location.href = '/member/login.html?referer=' +
    //         encodeURIComponent(referer || location.href)
    //       return false
    //     }
    //     return true
    //   }
    //   return false
    // },
    /**
     * 저장된 크레덴셜이 없을 때 confirm 창 없이 바로 로그인 창을 띄운다.
     */
    showRequiredLoginPopupWithoutConfirm(referer) {
      if (
        utils.cookies.getCredential() === 'none' &&
        utils.cookies.getDevice() === 'mobile'
      ) {
        window.location.href =
          '/member/login.html?referer=' +
          encodeURIComponent(referer || location.href)
      }
    },
    async showBillingPopup({
      productId,
      productType,
      returnUrl,
      contentType,
      contentId,
      promotionCode = '',
      canceledUrl,
    }) {
      const getDeviceFromPromotionCode = (promotionCode) => {
        if (promotionCode === 'forholder') {
          return isMobileDevice() ? 'mobile' : 'pc'
        } else {
          return 'mobile'
        }
      }
      window.addEventListener('message', function (e) {
        if (e.origin === location.origin) {
          const eventMessage = get(e.data, 'eventMessage', e.data)
          if (eventMessage === 'voucherPurchase') {
            const credential = utils.cookies.getCredential()
            const isMultiLine =
              Number(utils.cookies.userInfo('profilecount')) !== 1
            utils.login
              .credentialAutoLogin(credential, isMultiLine)
              .then((response) => {})
          }
        }
      })

      // window.voucherAutoLogin = function () {
      //   const credential = utils.cookies.getCredential()
      //   const isMultiLine = Number(utils.cookies.userInfo('profilecount')) !== 1
      //   utils.login.credentialAutoLogin(credential, isMultiLine).then((response) => {
      //   })
      // }

      const openBillingPopup = () => {
        let popup = window.open(
          'https://bill.wavve.com/Payment' +
            '?credential=' +
            encodeURIComponent(credential) +
            '&productId=' +
            encodeURIComponent(productId) +
            '&productType=' +
            productType +
            '&returnUrl=' +
            encodeURIComponent(returnUrl) +
            '&contentType=' +
            encodeURIComponent(contentType) +
            '&contentid=' +
            encodeURIComponent(contentId) +
            '&promotionCode=' +
            encodeURIComponent(promotionCode) +
            '&canceledUrl=' +
            encodeURIComponent(canceledUrl) +
            '&deviceTypeId=' +
            getDeviceFromPromotionCode(promotionCode) +
            '&marketTypeId=generic&partnerUserKey=',
          'scrollbars=yes',
        )
        popup.window.focus()
      }
      let credential = utils.cookies.getCredential()

      if (credential === 'none') {
        window.location.href =
          '/member/login.html?referer=' + encodeURIComponent(location.href)
      } else {
        // 소셜 로그인 회원일 때 다시 한번 결제 확인
        let loginType = utils.cookies.userInfo('type')
        if (SNS_TYPE_LIST.indexOf(loginType) > -1) {
          if (await utils.asyncConfirm(MSG_VOUCHER_SNS_ALERT)) {
            openBillingPopup()
          }
        } else {
          openBillingPopup()
        }
      }
    },

    async showCoinPopup(isAuto, returnUrl, isDcb = false) {
      const coinOpenBillingPopup = () => {
        let popup = window.open(
          'https://bill.wavve.com/ProductCoin' +
            '?credential=' +
            encodeURIComponent(credential) +
            '&isAuto=' +
            (isAuto ? 1 : 0) +
            '&returnUrl=' +
            encodeURIComponent(returnUrl) +
            '&pgname=' +
            (isDcb ? 'skt_dcb' : '') +
            '&deviceTypeId=mobile&marketTypeId=generic',
          '',
          'scrollbars=yes',
        )
        popup.window.focus()
      }
      let credential = utils.cookies.getCredential()
      if (credential === 'none' && utils.cookies.getDevice() === 'mobile') {
        let confirmLogin = await utils.asyncConfirm(MSG_NEED_FOR_MOVING_LOGIN)
        if (confirmLogin) {
          window.location.href =
            '/member/login.html?referer=' + encodeURIComponent(location.href)
          return false
        }
      } else {
        let loginType = utils.cookies.userInfo('type')
        if (SNS_TYPE_LIST.indexOf(loginType) > -1) {
          if (await utils.asyncConfirm(MSG_VOUCHER_SNS_ALERT)) {
            coinOpenBillingPopup()
          }
        } else {
          coinOpenBillingPopup()
        }
      }
    },
    checkInstallApps(passURL) {
      const userAgent = navigator.userAgent
      const isIpad =
        userAgent.match(/Mac|MacIntel/) &&
        navigator.maxTouchPoints &&
        navigator.maxTouchPoints > 2
      /* [sean:QA30-4182] intent > captvpooq 대체
      let appPackage = 'kr.co.captv.pooqV2';
      let appScheme = 'captvpooq';
      let addParam = '';
      let androidIntentURL = 'intent://' + passURL + '/' + addParam + '#Intent;scheme=' + appScheme + ';package=' + appPackage + ';end';
      */
      let hidden, visibilityChange
      if (typeof document.hidden !== 'undefined') {
        // Opera 12.10 and Firefox 18 and later support
        hidden = 'hidden'
        visibilityChange = 'visibilitychange'
      } else if (typeof document.msHidden !== 'undefined') {
        hidden = 'msHidden'
        visibilityChange = 'msvisibilitychange'
      } else if (typeof document.webkitHidden !== 'undefined') {
        hidden = 'webkitHidden'
        visibilityChange = 'webkitvisibilitychange'
      }

      let schemeURL = `captvpooq://${passURL}`

      const openIosApp = () => {
        document.addEventListener(visibilityChange, function () {
          if (document[hidden]) {
            if (window.appOpener) {
              clearTimeout(window.appOpener)
            }
          }
        })
        location.href = schemeURL
        window.appOpener = setTimeout(function () {
          location.href =
            'itms-apps://itunes.apple.com/kr/app/pug-pooq/id987782077?mt=8'
        }, 3000)
      }

      if (userAgent.match(/iPhone|iPad|iPod/i) || isIpad) {
        let iOsVersion = parseFloat(
          (navigator.userAgent.match(/\b[0-9]+_[0-9]+(?:_[0-9]+)?\b/) || [
            '',
          ])[0].replace(/_/g, '.'),
        )
        if (iOsVersion >= 9.2) {
          openIosApp()
        } else if (iOsVersion >= 9) {
          window.location.href =
            '/iosLaunch/iosLaunch.html?addParam=' +
            encodeURIComponent(schemeURL.replace('captvpooq://', ''))
        } else {
          window.open(
            '/iosLaunch/iosLaunch.html?addParam=' +
              encodeURIComponent(schemeURL.replace('captvpooq://', '')),
          )
        }
      } else if (userAgent.match(/Android/i)) {
        const isPlayerPath = passURL.substring(0, 7) === 'player/'
        let androidPassURL = isPlayerPath ? 'deeplink/' + passURL : passURL
        schemeURL = isPlayerPath
          ? schemeURL.replace('captvpooq://', 'captvpooq://deeplink/')
          : schemeURL
        if (userAgent.match(/Chrome/)) {
          // 안드로이드의 크롬에서는 intent만 동작하기 때문에 intent로 호출해야함
          if (utils.cookies.getDevice() === DEVICE_TYPE_ANDROID) {
            location.href = schemeURL
          } else {
            location.href = `intent://${androidPassURL}#Intent;scheme=captvpooq;package=kr.co.captv.pooqV2;end`
          }
        } else {
          location.href = `https://link.wavve.com/${passURL}`
          // 크롬 이외의 브라우저들
          // let iFrame = document.createElement('iframe')
          // iFrame.style.visibility = 'hidden'
          // iFrame.src = schemeURL
          // document.body.appendChild(iFrame)
          // document.body.removeChild(iFrame) // back 호출시 캐싱될 수 있으므로 제거
        }
      }
    },
  },
}

export default utils
